import axiosClient from '../../common/axiosInstance';

export const ExpertiseService = {
  getInfoCar: (company, codeSnippet) => {
    return axiosClient.get(`/partner/get-info-car-autocare-${company}/${codeSnippet}`);
  },

  getDoctype: (company, id, insurerBranchId) => {
    let params = {
      InsurerBranchId: insurerBranchId,
      policyNumber: id,
    };
    let subUrl = '-partner';

    if (company === 'liberty') {
      subUrl = '-liberty/' + id;
      params = {};
    }

    return axiosClient.get(`/partner/get-doctype-autocare${subUrl}`, { params });
  },

  validatePreinspection: (url, params) => {
    return axiosClient.get(url, { params });
  },

  confirmInfo: (body) => {
    return axiosClient.post('/partner/confirm-info', body);
  },

  deleteImages: (pidPpiSysId, data) => {
    return axiosClient.post(`/partner/delete-images-pi/${pidPpiSysId}`, { data });
  },

  createDoctype: (orderId, doctype) => {
    return axiosClient.post(`/partner/create-doctype-pi/${orderId}`, { doctype });
  },

  aiCheck: (params) => {
    return axiosClient.put(`/partner/ai-check`, null, { params });
  },

  verifyPolicyImage: (urlAppend, formData, config) => {
    return axiosClient.post('/partner/verify-policy-image-autocare-' + urlAppend, formData, config);
  },
};
